import {
    Component,
    Output,
    EventEmitter
} from '@angular/core';
import {
    FormGroup,
    FormControl,
    Validators
} from '@angular/forms';

import { ApiService, AuthService } from '../../core/upgraded-providers';
import { AlertService, ConfirmService } from '../../ui.module';

const ERROR_SUBSCRIBED = 'subscribed';
const ERROR_CREDITS = 'credits';
const ERROR_INVALID_COUPON = 'invalid coupon';

@Component({
    selector: 'app-coupon',
    templateUrl: './coupon.component.pug',
    styleUrls: ['./coupon.component.less'],
})
export class CouponComponent {
    @Output() close: EventEmitter<any> = new EventEmitter();

    public form = new FormGroup({
        code: new FormControl('', Validators.required)
    });

    constructor(
        private _alert: AlertService,
        private _confirm: ConfirmService,

        private _apiSrv: ApiService,
        private _authSrv: AuthService
    ) {
    }

    async onSubmit(convert) {
        const code = this.form.controls.code.value;

        return this._apiSrv.post('xsolla/coupon', { code, convert })
            .then((data) => {
                this.showSuccessActivateCouponDialog(data);
                this._authSrv.check();
                this.onClose();
            })
            .catch((error) => {
                if (error === ERROR_SUBSCRIBED) {
                    this.showConfirmSubscribedDialog()
                        .then(() => this.onSubmit(true));

                    return;
                }

                if (error === ERROR_CREDITS) {
                    this.showConfirmCreditsDialog()
                        .then(() => this.onClose())
                        .then(() => location.href = '#!/account/subscription');

                    return;
                }

                if (error === ERROR_INVALID_COUPON) {
                    this.form.controls.code.setErrors({ 'invalidCoupon': true });

                    return;
                }

                this.form.controls.code.setErrors({ 'unknownError': true });
            })
            .finally(() => {});
    }

    private showSuccessActivateCouponDialog(data): Promise<any> {
        let message = 'Thank you!';

        if (data.days) {
            message = `Thank you! You have received ${ data.days } ${ data.days === 1 ? 'day' : 'days' } of CPU subscription`;
        }

        if (data.credits) {
            message = `Thank you! You have received ${ data.credits } CPU Credits.`;
        }

        return this._alert.show({ data: {
            message,
            icon: 'app2/assets/order/token-accept.svg'
        }});
    }

    private showConfirmSubscribedDialog(): Promise<any> {
        return this._confirm.show({ data: {
            // tslint:disable-next-line
            message: 'You already have an active subscription. Would you like to convert this credits coupon into subscription time? The conversion will be done based on 90 credits/day rate.'
        }});
    }

    private showConfirmCreditsDialog(): Promise<any> {
        return this._confirm.show({ data: {
            // tslint:disable-next-line
            message: 'You still have CPU Credits to spend. To activate your subscription under the new model, please convert your Credits into subscription days.'
        }});
    }


    onClose() {
        this.close.emit();
    }
}
